import { render, staticRenderFns } from "./app_nav.vue?vue&type=template&id=ff664ef2&scoped=true"
import script from "./app_nav.vue?vue&type=script&lang=js"
export * from "./app_nav.vue?vue&type=script&lang=js"
import style0 from "./app_nav.vue?vue&type=style&index=0&id=ff664ef2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff664ef2",
  null
  
)

export default component.exports